export const GATEWAY_PROFILE = {
  username: "FounderTrey",
  displayRank: "Founder Level 7",
  xpCurrent: 12400,
  xpNext: 15000,
  heroQuote: "The future of Oshar is in your hands.",
};

/** Top-center links (Dashboard lives in the right identity cluster on GatewayTopNav). */
export const GATEWAY_NAV_TOP = [
  { label: "Oshar Real Estate", path: "/world/oshar/real-estate" },
  { label: "TreydoraVR", path: "/world/oshar", end: true },
  { label: "Chronicles", path: "/chronicles" },
  { label: "Library", path: "/library" },
  { label: "Community", path: "/world", end: true },
  { label: "Marketplace", path: "/marketplace" },
];

/**
 * Left rail — Gateway navigation.
 * Most entries are live routes; TreydoraVR uses `path: "#"` as a placeholder — GatewaySidebar renders it as a disabled control.
 * Support is live: `/dashboard/support` → Support Command Center (TreydoraEdBackend `/api/support/*`).
 */
export const GATEWAY_SIDEBAR_MAIN = [
  { key: "overview", label: "Overview", icon: "fa-chart-pie", path: "/dashboard" },
  {
    key: "storefront",
    label: "My Storefront",
    icon: "fa-store",
    path: "/dashboard/my-store",
    badge: "Coming Soon",
    badgeTitle: "Preview — seller tools not live yet",
  },
  { key: "tvr", label: "TreydoraVR", icon: "fa-vr-cardboard", path: "#" }, // placeholder: sidebar renders disabled control (see GatewaySidebar)
  { key: "library", label: "Library", icon: "fa-book-open", path: "/dashboard/library" },
  {
    key: "quests",
    label: "Quests",
    icon: "fa-shield-alt",
    path: "/dashboard/quests",
    badge: "Coming Soon",
    badgeTitle: "Quest dashboard preview — full progression coming soon",
  },
  { key: "support", label: "Support", icon: "fa-headset", path: "/dashboard/support" },
];

export const GATEWAY_SIDEBAR_IDENTITY = {
  title: "Treydora",
  tagline: "The Future of Oshar",
};

/** Sidebar citizen dossier (mock Gateway identity). */
export const GATEWAY_SIDEBAR_DOSSIER = {
  name: "FounderTrey",
  founderRank: "Founder Level 7",
  accessRank: "Founder",
  gatewayStatus: "Active",
};

export const GATEWAY_SIDEBAR_FOOTER = {
  clockLabel: "Oshar Time",
  cycle: "Cycle 2290.07.14",
  systemStatus: "All Systems Operational",
};

export const GATEWAY_STATUS_CHIPS = [
  {
    key: "reserved",
    label: "Reserved",
    sublabel: "Card access",
    value: "2",
    tone: "amber",
    icon: "fa-bookmark",
  },
  {
    key: "minted",
    label: "Minted",
    sublabel: "Wallet owned",
    value: "5",
    tone: "green",
    icon: "fa-coins",
  },
  {
    key: "claimable",
    label: "Claimable",
    sublabel: "NFT pending",
    value: "1",
    tone: "blue",
    icon: "fa-bolt",
  },
  {
    key: "watchlist",
    label: "Watchlist",
    sublabel: "Saved assets",
    value: "3",
    tone: "purple",
    icon: "fa-eye",
  },
];

/** Treydorex (TRDX) — Gateway preview; not on-chain totals. */
export const GATEWAY_WALLET_MOCK = {
  treydorexBalance: "24,975.00",
  treydorexSubtext:
    "Treydorex unlocks ecosystem access, property utility, and Oshar participation.",
  accountStatus: "Verified",
};

export const GATEWAY_MAP_OVERLAYS = [
  { label: "Commerce Ward", style: { top: "18%", left: "22%" } },
  { label: "Residence Ring", style: { top: "62%", left: "18%" } },
  { label: "Artisan Forge", style: { top: "38%", left: "48%" } },
  { label: "Guild Quarter", style: { top: "72%", left: "52%" } },
  { label: "Waterfront", style: { top: "54%", left: "68%" } },
  { label: "District Central", style: { top: "26%", left: "72%" } },
];

export const GATEWAY_FEATURED_PROPERTIES = [
  {
    title: "Commercial Storefront",
    image: "02_commercial_storefront_card.png",
    status: "Minted",
    district: "Commerce Ward",
    tokenClass: "Genesis Access",
    action: "View Details",
    variant: "view",
  },
  {
    title: "Vendor Stall",
    image: "03_vendor_stall_card.png",
    status: "Reserved",
    district: "Commerce Ward",
    tokenClass: "Commerce Pass",
    action: "Complete Mint",
    variant: "mint",
  },
  {
    title: "Artisan Forge",
    image: "04_artisan_forge_card.png",
    status: "Claimable",
    district: "Artisan Quarter",
    tokenClass: "Forge Relic",
    action: "Claim NFT",
    variant: "claim",
  },
  {
    title: "Luxury Residence",
    image: "05_luxury_residence_card.png",
    status: "Minted",
    district: "Residence Ring",
    tokenClass: "Residence Prime",
    action: "View Details",
    variant: "view",
  },
];

/** icon + tone for circular activity glyphs */
export const GATEWAY_ACTIVITY = [
  { text: "Gateway quest previews rotate on a schedule.", ago: "2m ago", icon: "fa-gem", tone: "blue" },
  { text: "Browse Oshar Real Estate for live storefront tiers.", ago: "1h ago", icon: "fa-store", tone: "gold" },
  { text: "New quest available: Forge Alliances.", ago: "3h ago", icon: "fa-scroll", tone: "purple" },
  { text: "TreydoraVR system update completed.", ago: "5h ago", icon: "fa-vr-cardboard", tone: "cyan" },
  { text: "Welcome to Cycle 2290.", ago: "1d ago", icon: "fa-sun", tone: "green" },
];

export const GATEWAY_ECOSYSTEM = {
  chronicle: {
    title: "AI Chronicle / Lore Terminal",
    img: "07_ai_chronicle_lore_terminal.png",
    copy: [
      "Ask. Discover. Remember.",
      "Your AI companion for Oshar's living history.",
    ],
    button: "Open Chronicle",
    footer: "Public lore archive — browse chapters",
    accessLabel: "Public lore — treydora.com/chronicles",
    accessTone: "memory",
    thumbGlow: "memory",
  },
  vr: {
    title: "TreydoraVR Access",
    img: "08_treydoravr_gateway_access.png",
    copyLine: "Immersive exploration. True ownership. Real impact.",
    status: "Connected",
    button: "Launch TreydoraVR",
    accessLabel: "Spatial channel · Live",
    accessTone: "live",
    thumbGlow: "blue",
  },
  game: {
    title: "Game Access",
    img: "09_game_access_panel.png",
    copyLine: "Enter the world of Oshar and forge your legacy.",
    button: "Launch Experience",
    status: "Up to Date",
    accessLabel: "World client · Stable",
    accessTone: "stable",
    thumbGlow: "green",
  },
  library: {
    title: "Comic & Book Library",
    img: "10_comic_book_library_panel.png",
    button: "Open Library",
    footer: "Library catalog — purchases in My Library",
    accessLabel: "Archive lane · Vaulted",
    accessTone: "vault",
    thumbGlow: "gold",
  },
  quest: {
    title: "Quests & Progression",
    current: "Forge Alliances",
    progressCurrent: 1,
    progressTotal: 3,
    rewardChips: [
      { id: "xp", label: "500 XP", tone: "xp" },
      { id: "trdx", label: "250 TRDX", tone: "trdx" },
      { id: "emblem", label: "Rare Emblem", tone: "emblem" },
    ],
    rewardsLegal: "Preview reward track · illustrative only · not a payout or guarantee.",
    button: "View All Quests",
  },
};

export const GATEWAY_FOOTER = {
  announcement:
    "The Council gathers this Cycle to vote on new district expansions. Participate now!",
  proposalCta: "View Proposal",
  news: "Artisan Quarter expansion approved",
};
